import type { ReactNode } from 'react';

import { ReactComponent as AquaControlIcon } from 'atoms/icons/svg/sidebar/aqua-control.svg';

import { ReactComponent as HelpIcon } from 'atoms/icons/svg/sidebar/help.svg';

import { ReactComponent as CustomersIcon } from 'atoms/icons/svg/sidebar/customers.svg';
import { ReactComponent as DashboardIcon } from 'atoms/icons/svg/sidebar/home.svg';
import { ReactComponent as NotificationIcon } from 'atoms/icons/svg/sidebar/notification.svg';
import { ReactComponent as PensIcon } from 'atoms/icons/svg/sidebar/pens.svg';
import { ReactComponent as SettingIcon } from 'atoms/icons/svg/sidebar/setting.svg';
import { ReactComponent as SitesIcon } from 'atoms/icons/svg/sidebar/sites.svg';
import { ReactComponent as TopBoxesIcon } from 'atoms/icons/svg/sidebar/topboxes.svg';
import { ReactComponent as UsersIcon } from 'atoms/icons/svg/sidebar/users.svg';
import { ReactComponent as RobotsIcon } from 'atoms/icons/svg/sidebar/robots.svg';
import { ReactComponent as StatisticsIcon } from 'atoms/icons/svg/sidebar/statistics.svg';
import BugReportIcon from '@mui/icons-material/BugReport';
// import { ReactComponent as LocationIcon } from 'atoms/icons/svg/sidebar/location.svg';
import './SideMenu.scss';
import { Business } from '@mui/icons-material';

/**
 * Link MUST be defined either on an icon or on a sub-icon
 */
export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  items?: MenuItem[];
  className?: string;
  name:
    | 'Overview'
    | 'Statistics'
    | 'Departments'
    | 'Hole Detections'
    | 'Locations'
    | 'Pens'
    | 'Users'
    | 'Customers'
    | 'Setting'
    | 'AquaControl'
    | 'Notifications'
    | 'Sites'
    | 'Help'
    | 'Top boxes'
    | 'Robots'
    | 'Auto Recordings'
    | 'Manual Recordings';

  id: string;
  onClick?: () => void;
}

export interface MenuSection {
  items: MenuItem[];
  heading?: 'Management';
}

const sidebarMenuItems: MenuSection[] = [
  {
    items: [
      {
        id: 'dashboard',
        name: 'Overview',
        icon: <DashboardIcon />,
        link: '/dashboard',
      },
      {
        id: 'statistics',
        name: 'Statistics',
        icon: <StatisticsIcon />,
        link: '/statistics',
      },

      {
        id: 'hole-detections',
        name: 'Hole Detections',
        icon: <BugReportIcon />,
        link: '/holes',
      },
    ],
  },
  {
    heading: 'Management',
    items: [
      {
        id: 'users',
        name: 'Users',
        link: '/users',
        icon: <UsersIcon />,
      },
      {
        id: 'departments',
        name: 'Departments',
        icon: <Business />,
        link: '/departments',
      },
      {
        id: 'setting',
        name: 'Setting',
        link: '/setting',
        icon: <SettingIcon />,
      },
      {
        id: 'customers',
        name: 'Customers',
        link: '/customers',
        icon: <CustomersIcon />,
      },

      {
        id: 'sites',
        name: 'Sites',
        link: '/sites',
        icon: <SitesIcon />,
      },
      {
        id: 'pens',
        name: 'Pens',
        icon: <PensIcon />,
        link: '/pens',
      },
      {
        id: 'topboxes',
        name: 'Top boxes',
        link: '/topboxes',
        icon: <TopBoxesIcon />,
      },
      {
        id: 'robots',
        name: 'Robots',
        icon: <RobotsIcon />,
        link: '/topboxes/robots',
      },
      {
        id: 'aquaControl',
        name: 'AquaControl',
        link: '/aquaControl',
        icon: <AquaControlIcon />,
      },
      {
        id: 'notifipcations',
        name: 'Notifications',
        link: '/notifipcations',
        icon: <NotificationIcon />,
      },
    ],
  },
  {
    items: [
      {
        id: 'help',
        name: 'Help',
        link: '/help',
        icon: <HelpIcon />,
      },
    ],
  },
];

export default sidebarMenuItems;
